<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                class="primary"
                dense
                :headers="personalWeaponsTableHeaders"
                :items="armasPersonal"
                :search="searchPersonalWeapon"
                hide-default-footer
                calculate-widths
                v-if="armasPersonal && armasPersonal.length > 0"
              >
                <template v-slot:item.cancelacion="{ item }">
                  <v-btn icon color="error" @click="triggerCancelaArmaPersonal(item)">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:item.personalWeaponStatus="{ item }">
                  <v-switch
                    :input-value="getArmaPersonalEstatus(item)"
                    color="secondary"
                    @change="triggerSaveEntregaRecepcion(item, $event)"
                    inset
                  ></v-switch>
                </template>
                <template v-slot:item.municiones="{ item }">
                  <v-btn icon color="secondary" @click="openMunicionesArmaDialog(item)">
                    <v-icon>mdi-ammunition</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
              <div v-else class="text-subtitle-1 text--primary mt-4">
                El personal seleccionado no tiene armas asignadas.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  name: 'ListadoArmasModal',
  props: {
    selectedPersonal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      personalWeaponsTableHeaders: [
        { text: '', value: 'cancelacion', width: '40px' },
        { text: 'Clase', value: 'Arma.CatClase.clase', width: '160px' },
        { text: 'Tipo', value: 'Arma.CatClase.CatTipo.title', width: '70px' },
        { text: 'Marca', value: 'Arma.CatModelo.CatMarca.title', width: '80px' },
        { text: 'Modelo', value: 'Arma.CatModelo.modelo', width: '80px' },
        { text: 'Calibre', value: 'Arma.CatCalibre.title', width: '80px' },
        { text: 'No. de serie', value: 'Arma.serie', width: '80px' },
        { text: 'Armeros', value: 'Arma.armeros', width: '90px' },
        { text: 'En armería | En campo', value: 'personalWeaponStatus', width: '80px', filterable: false },
        { text: '', value: 'municiones', width: '40px', filterable: false },
      ],
      searchPersonalWeapon: '',
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('tipoArma', {
      weaponTypes: 'getTipoArmas',
    }),

    ...mapGetters('marcaArma', {
      weaponBrands: 'getMarcaArma',
    }),

    ...mapGetters('tipoEntregaArma', {
      tipoEntrega: 'getTiposEntrega',
    }),

    ...mapGetters('bitacoraEntregaRecepcion', {
      bitacora: 'getBitacoraEntregaRecepcion',
    }),
  },
  methods: {
    ...mapActions('armaPersonal', ['fetchArmasPersonal', 'updateEstatusArmaPersonal', 'cancelaArmaPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('municionArma', ['fetchMunicionArma']),

    async triggerCancelaArmaPersonal(armaPersonal) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_CANCELAR_ARMA,
        props: {
          armaPersonal,
          onConfirmCancel: async () => {
            await this.cancelaArmaPersonal(armaPersonal)
            await this.fetchArmasPersonal(this.selectedPersonal.idPersonal)
            this.$store.commit('dialog/CLOSE_DIALOG')
          },
        },
      })
    },
    async triggerSaveEntregaRecepcion(armaPersonal, event) {
      if (event) {
        await this.saveEntregaRecepcionArma({
          idPersonal: armaPersonal.fk_idPersonal,
          fk_idTipoEntrega: 2,
          fk_idArmaPersonal: armaPersonal.idArmaPersonal,
          armaDescargada: false,
        })
      } else {
        await this.saveEntregaRecepcionArma({
          idPersonal: armaPersonal.fk_idPersonal,
          fk_idTipoEntrega: 1,
          fk_idArmaPersonal: armaPersonal.idArmaPersonal,
          armaDescargada: true,
        })
      }
      await this.fetchBitacoraEntregaRecepcion()
    },
    getArmaPersonalEstatus: function (armaPersonal) {
      var bitacora = []
      bitacora = this.bitacora.filter((entregaRecepcion) => {
        return entregaRecepcion.fk_idArmaPersonal == armaPersonal.idArmaPersonal
      })
      if (bitacora.length > 0) {
        if (bitacora[bitacora.length - 1].fk_idTipoEntrega == 2) {
          return true
        } else return false
      } else return false
    },
    async openMunicionesArmaDialog(armaPersonal) {
      await this.fetchMunicionArma(armaPersonal.idArmaPersonal)
      this.municionesArmaDialog = true
    },
  },
  mounted() {
    if (this.selectedPersonal && this.selectedPersonal.idPersonal) {
      this.fetchArmasPersonal(this.selectedPersonal.idPersonal)
    }
  },
  watch: {
    selectedPersonal(newVal) {
      if (newVal && newVal.idPersonal) {
        this.fetchArmasPersonal(newVal.idPersonal)
      }
    },
  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>
